import React from "react";

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  type?: "button" | "submit" | "reset";
  className?: string;
  style?: React.CSSProperties;
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  disabled = false,
  loading = false,
  type = "button",
  className = "",
  style = {},
}) => {
  const isDisabled = disabled || loading;

  const baseStyles: React.CSSProperties = {
    background: "#000000",
    color: "white",
    border: "none",
    padding: "12px 24px",
    borderRadius: "25px",
    fontWeight: "500",
    cursor: isDisabled ? "not-allowed" : "pointer",
    transition: "background-color 0.2s",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    fontSize: "14px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    minHeight: "44px",
    ...style,
  };

  const hoverStyles: React.CSSProperties = {
    backgroundColor: isDisabled ? "#a0aec0" : "#333333",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      className={className}
      style={baseStyles}
      onMouseEnter={(e) => {
        if (!isDisabled) {
          (e.target as HTMLButtonElement).style.backgroundColor =
            hoverStyles.backgroundColor!;
        }
      }}
      onMouseLeave={(e) => {
        if (!isDisabled) {
          (e.target as HTMLButtonElement).style.backgroundColor = "#000000";
        }
      }}
    >
      {loading && (
        <div
          style={{
            width: "16px",
            height: "16px",
            border: "2px solid transparent",
            borderTop: "2px solid white",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
      )}
      {children}
    </button>
  );
};

export default Button;
